import { IInputElement } from '../../types';

import { InputTextElement } from '../../form-inputs';

type TFirstNameInputFieldProps = Pick<
  IInputElement,
  | 'className'
  | 'classNameInput'
  | 'classNameLabel'
  | 'error'
  | 'label'
  | 'name'
  | 'onBlurCallback'
  | 'onChangeCallback'
  | 'onError'
  | 'value'
>;

/**
 * -----------------------------------------------------------------------------
 * This is used to capture the first name of a person or organization,
 * and tries to add constraints that are used to validate the expected format of
 * a valid person's first name.
 */
export function FirstNameInputField({
  className,
  classNameInput,
  classNameLabel,
  error,
  label,
  name,
  onBlurCallback,
  onChangeCallback,
  onError,
  value,
}: TFirstNameInputFieldProps) {
  return (
    <InputTextElement
      className={className}
      classNameInput={classNameInput}
      classNameLabel={classNameLabel}
      constraints={{
        feedbackLabel: 'First Name',
        maxLength: 50,
        minLength: 2,
        required: true,
        format: 'person-name',
      }}
      error={error}
      hasClearButton
      label={label}
      name={name}
      onBlurCallback={onBlurCallback}
      onChangeCallback={onChangeCallback}
      onError={onError}
      placeholder="Please enter a first name"
      showIsRequired={false}
      type="text"
      value={value}
    />
  );
}
